import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import IconPlay from 'components/icons/IconPlay';
import IconPlus from 'components/icons/iconPlus';
import IconMinus from 'components/icons/iconMinus';
import IconClose from 'components/icons/iconClose';
import IconArrowLeftWhite from 'components/icons/Slider/iconArrowLeftWhite';
import IconArrowRightWhite from 'components/icons/Slider/iconArrowRightWhite';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import JBProductImage from 'components/essentials/JBImage/JBProductImage';
import useVideoMetadata from 'hooks/useVideoMetadata';
import useScrollSelectedIntoView from 'hooks/useScrollSelectedIntoView';
import { getMainImageImgixPropsForPhoto } from '../PDPDesktopHeroGallery/helpers/imgix-props';
import usePDPDesktopHeroSizeProps from '../PDPDesktopHeroGallery/helpers/usePDPDesktopHeroSizeProps';
import PDPProductIntroVideo from '../PDPDesktopHeroGallery/PDPProductIntroVideo';
import PDPGalleryRevampCircleButton from './PDPGalleryRevampCircleButton';
import PDPGalleryRevampLifestyleThumb from './PDPGalleryRevampLifestyleThumb';
const ZOOM_LEVELS = [1, 1.5, 2];

// Expanded lifestyle gallery (CON-8444): 2-col thumb grid + selected photo/video
const PDPGalleryRevampExpandedGallery = t0 => {
  const $ = _c(69);
  const {
    enableCrops,
    initialIndex: t1,
    introVideoId,
    onClose,
    photos: t2,
    productName,
    viewGalleryImageEvent
  } = t0;
  const initialIndex = t1 === undefined ? 0 : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const photos = t3;
  const [selectedIndex, setSelectedIndex] = useState(initialIndex);
  const [isVideoSelected, setIsVideoSelected] = useState(false);
  const [zoomIndex, setZoomIndex] = useState(0);
  const thumbGridRef = useRef(null);
  let t4;
  if ($[2] !== introVideoId) {
    t4 = {
      videoId: introVideoId
    };
    $[2] = introVideoId;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    thumbnail: videoThumbnailUrl
  } = useVideoMetadata(t4);
  const t5 = isVideoSelected ? 0 : selectedIndex + (introVideoId ? 1 : 0);
  let t6;
  if ($[4] !== t5) {
    t6 = {
      axis: "y",
      scrollerRef: thumbGridRef,
      selectedIndex: t5
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  useScrollSelectedIntoView(t6);
  const mainPhotoSizeProps = usePDPDesktopHeroSizeProps();
  const selectedPhoto = photos[selectedIndex] ?? photos[0];
  const zoom = ZOOM_LEVELS[zoomIndex];
  let t7;
  if ($[6] !== photos || $[7] !== viewGalleryImageEvent) {
    t7 = index => {
      setSelectedIndex(index);
      setIsVideoSelected(false);
      setZoomIndex(0);
      const src = photos[index]?.src;
      viewGalleryImageEvent?.({
        imageLocation: "Hero Gallery",
        imageFilename: src?.split("/").pop() || "",
        position: index,
        totalImages: photos.length
      });
    };
    $[6] = photos;
    $[7] = viewGalleryImageEvent;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const selectPhoto = t7;
  const hasMultiplePhotos = photos.length > 1;
  let t8;
  if ($[9] !== photos.length || $[10] !== selectPhoto || $[11] !== selectedIndex) {
    t8 = () => selectPhoto((selectedIndex - 1 + photos.length) % photos.length);
    $[9] = photos.length;
    $[10] = selectPhoto;
    $[11] = selectedIndex;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const goToPrevious = t8;
  let t9;
  if ($[13] !== photos.length || $[14] !== selectPhoto || $[15] !== selectedIndex) {
    t9 = () => selectPhoto((selectedIndex + 1) % photos.length);
    $[13] = photos.length;
    $[14] = selectPhoto;
    $[15] = selectedIndex;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const goToNext = t9;
  let t10;
  let t11;
  if ($[17] !== goToNext || $[18] !== goToPrevious || $[19] !== hasMultiplePhotos || $[20] !== onClose) {
    t10 = () => {
      const handleKeyDown = event => {
        if (event.key === "Escape") {
          onClose();
        } else {
          if (hasMultiplePhotos && event.key === "ArrowLeft") {
            goToPrevious();
          } else {
            if (hasMultiplePhotos && event.key === "ArrowRight") {
              goToNext();
            }
          }
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
    };
    t11 = [hasMultiplePhotos, goToPrevious, goToNext, onClose];
    $[17] = goToNext;
    $[18] = goToPrevious;
    $[19] = hasMultiplePhotos;
    $[20] = onClose;
    $[21] = t10;
    $[22] = t11;
  } else {
    t10 = $[21];
    t11 = $[22];
  }
  useEffect(t10, t11);
  let t12;
  if ($[23] !== introVideoId || $[24] !== isVideoSelected || $[25] !== videoThumbnailUrl) {
    t12 = !!introVideoId && <PDPGalleryRevampLifestyleThumb ariaLabel="Play product video" className="h-[87px] w-full" imgSize={{
      width: 120,
      height: 87
    }} src={videoThumbnailUrl} isSelected={isVideoSelected} onClick={() => {
      setIsVideoSelected(true);
      setZoomIndex(0);
    }} icon={<IconPlay width={24} height={24} />} />;
    $[23] = introVideoId;
    $[24] = isVideoSelected;
    $[25] = videoThumbnailUrl;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== isVideoSelected || $[28] !== photos || $[29] !== selectPhoto || $[30] !== selectedIndex) {
    let t14;
    if ($[32] !== isVideoSelected || $[33] !== selectPhoto || $[34] !== selectedIndex) {
      t14 = (t15, index_0) => {
        const {
          id,
          src: src_0
        } = t15;
        return <PDPGalleryRevampLifestyleThumb key={`PDPGalleryRevampExpandedThumb${id}`} className="h-[87px] w-full" imgSize={{
          width: 120,
          height: 87
        }} src={src_0} isSelected={!isVideoSelected && index_0 === selectedIndex} onClick={() => selectPhoto(index_0)} />;
      };
      $[32] = isVideoSelected;
      $[33] = selectPhoto;
      $[34] = selectedIndex;
      $[35] = t14;
    } else {
      t14 = $[35];
    }
    t13 = photos.map(t14);
    $[27] = isVideoSelected;
    $[28] = photos;
    $[29] = selectPhoto;
    $[30] = selectedIndex;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[36] !== t12 || $[37] !== t13) {
    t14 = <div ref={thumbGridRef} className="flex-none grid grid-cols-2 gap-2.5 content-start w-[250px] h-full overflow-y-auto">{t12}{t13}</div>;
    $[36] = t12;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== goToNext || $[40] !== goToPrevious || $[41] !== hasMultiplePhotos) {
    t15 = hasMultiplePhotos && <><button type="button" onClick={goToPrevious} className="group absolute left-0 top-0 h-full w-16 z-[2] flex items-center justify-center hover:cursor-pointer focus-visible:outline-brand before:absolute before:inset-0 before:rounded-l before:opacity-0 before:transition-opacity before:duration-300 hover:before:opacity-100 before:[background:linear-gradient(90deg,rgba(0,0,0,.35)_.06%,hsla(0,0%,76.9%,0)_99.94%)]" aria-label="Previous image"><span className="relative items-center flex justify-center h-9 w-9 rounded-full bg-white border border-solid border-gray-light6 transition-colors duration-200 group-hover:bg-gray-light9 [&_svg_path]:fill-gray-dark"><IconArrowLeftWhite width={15} height={15} /></span><VisuallyHidden>Previous image</VisuallyHidden></button><button type="button" onClick={goToNext} className="group absolute right-0 top-0 h-full w-16 z-[2] flex items-center justify-center hover:cursor-pointer focus-visible:outline-brand before:absolute before:inset-0 before:rounded-r before:opacity-0 before:transition-opacity before:duration-300 hover:before:opacity-100 before:[background:linear-gradient(270deg,rgba(0,0,0,.35)_.06%,hsla(0,0%,76.9%,0)_99.94%)]" aria-label="Next image"><span className="relative items-center flex justify-center h-9 w-9 rounded-full bg-white border border-solid border-gray-light6 transition-colors duration-200 group-hover:bg-gray-light9 [&_svg_path]:fill-gray-dark"><IconArrowRightWhite width={15} height={15} /></span><VisuallyHidden>Next image</VisuallyHidden></button></>;
    $[39] = goToNext;
    $[40] = goToPrevious;
    $[41] = hasMultiplePhotos;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== enableCrops || $[44] !== introVideoId || $[45] !== isVideoSelected || $[46] !== mainPhotoSizeProps || $[47] !== productName || $[48] !== selectedPhoto || $[49] !== zoom) {
    t16 = isVideoSelected && introVideoId ? <div className="h-full w-full"><PDPProductIntroVideo videoId={introVideoId} /></div> : !!selectedPhoto?.src && <div style={{
      transform: `scale(${zoom})`
    }} className="h-full w-full origin-center transition-transform duration-200 ease-out"><JBProductImage className="h-full w-full object-cover select-none" alt={productName ? String(productName) : ""} {...getMainImageImgixPropsForPhoto(selectedPhoto, enableCrops)} {...mainPhotoSizeProps} lazy={false} priority={true} /></div>;
    $[43] = enableCrops;
    $[44] = introVideoId;
    $[45] = isVideoSelected;
    $[46] = mainPhotoSizeProps;
    $[47] = productName;
    $[48] = selectedPhoto;
    $[49] = zoom;
    $[50] = t16;
  } else {
    t16 = $[50];
  }
  let t17;
  if ($[51] !== t16) {
    t17 = <div className="h-full overflow-hidden flex rounded">{t16}</div>;
    $[51] = t16;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== t15 || $[54] !== t17) {
    t18 = <div className="relative flex-1 min-w-0">{t15}{t17}</div>;
    $[53] = t15;
    $[54] = t17;
    $[55] = t18;
  } else {
    t18 = $[55];
  }
  let t19;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <IconClose width={9} height={9} />;
    $[56] = t19;
  } else {
    t19 = $[56];
  }
  let t20;
  if ($[57] !== onClose) {
    t20 = <PDPGalleryRevampCircleButton ariaLabel="Close gallery" onClick={onClose}>{t19}</PDPGalleryRevampCircleButton>;
    $[57] = onClose;
    $[58] = t20;
  } else {
    t20 = $[58];
  }
  let t21;
  if ($[59] !== isVideoSelected || $[60] !== zoomIndex) {
    t21 = !isVideoSelected && <><PDPGalleryRevampCircleButton ariaLabel="Zoom in" disabled={zoomIndex >= ZOOM_LEVELS.length - 1} onClick={() => setZoomIndex(_temp)}><IconPlus width={15} height={15} /></PDPGalleryRevampCircleButton><PDPGalleryRevampCircleButton ariaLabel="Zoom out" disabled={zoomIndex <= 0} onClick={() => setZoomIndex(_temp2)}><IconMinus width={15} height={15} /></PDPGalleryRevampCircleButton></>;
    $[59] = isVideoSelected;
    $[60] = zoomIndex;
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  let t22;
  if ($[62] !== t20 || $[63] !== t21) {
    t22 = <div className="absolute flex flex-col gap-2.5 right-6 top-6 z-[2]">{t20}{t21}</div>;
    $[62] = t20;
    $[63] = t21;
    $[64] = t22;
  } else {
    t22 = $[64];
  }
  let t23;
  if ($[65] !== t14 || $[66] !== t18 || $[67] !== t22) {
    t23 = <div className="relative flex gap-3 h-full p-3" data-xc="PDPGalleryRevampExpandedGallery">{t14}{t18}{t22}</div>;
    $[65] = t14;
    $[66] = t18;
    $[67] = t22;
    $[68] = t23;
  } else {
    t23 = $[68];
  }
  return t23;
};
PDPGalleryRevampExpandedGallery.propTypes = {
  enableCrops: PropTypes.bool,
  initialIndex: PropTypes.number,
  introVideoId: PropTypes.string,
  onClose: PropTypes.func,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    src: PropTypes.string.isRequired
  })),
  productName: PropTypes.string,
  viewGalleryImageEvent: PropTypes.func
};
export default PDPGalleryRevampExpandedGallery;
function _temp(prev) {
  return Math.min(prev + 1, ZOOM_LEVELS.length - 1);
}
function _temp2(prev_0) {
  return Math.max(prev_0 - 1, 0);
}